export default __webpack_public_path__ + "static/media/coffe2.440bb3a4.jpg";